/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingbacktotools3Inputs */

const en_crosspostingbacktotools3 = /** @type {(inputs: Crosspostingbacktotools3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to place`)
};

const de_crosspostingbacktotools3 = /** @type {(inputs: Crosspostingbacktotools3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zum Ort`)
};

/**
* | output |
* | --- |
* | "Back to place" |
*
* @param {Crosspostingbacktotools3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingbacktotools3 = /** @type {((inputs?: Crosspostingbacktotools3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingbacktotools3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingbacktotools3(inputs)
	return de_crosspostingbacktotools3(inputs)
});
export { crosspostingbacktotools3 as "crosspostingBackToTools" }